import {Startup} from '@services/model/startup';
import {ProductResource} from '@services/resource/product-resource';
import {StartupResource} from '@services/resource/startup-resource';
import {Product} from '@services/model/product';
import {Application} from '@services/model/application';
import {ApplicationResource} from '@services/resource/application-resource';

export class Produktblatt {
  constructor(
    public readonly product: Product,
    public readonly startup: Startup,
    public readonly applications: Application[],
  ) {}

  public static fromResource(r: ProduktblattResource) {
    const p = Product.fromResource(r.product);
    const s = Startup.fromResource(r.startup);
    const a = Application.fromResources(r.applications);
    return new Produktblatt(p, s, a);
  }
}

export interface ProduktblattResource {
  product: ProductResource;
  startup: StartupResource;
  applications: ApplicationResource[];
}
